<script setup lang="ts">
import { useSelectTechIssueType } from '../../../model/additional-info/support/info-technical-issue/select-tech-issue-type.hook'
import ListTaskInfo from '../../task-info/ListTaskInfo.vue'
import RowTaskInfo from '../../task-info/RowTaskInfo.vue'
import SelectTechIssueType from './info-technical-issue/SelectTechIssueType.vue'

defineOptions({
  name: 'InfoTechnicalIssue',
})

const { isRequired } = useSelectTechIssueType()

</script>

<template>
  <ListTaskInfo>
    <RowTaskInfo
      title="Tech issue type"
      :required="isRequired"
    >
      <SelectTechIssueType />
    </RowTaskInfo>
  </ListTaskInfo>
</template>
